// extracted by mini-css-extract-plugin
export var footer = "_qs-5";
export var fulfillmentInput = "_qs-0";
export var shipDateInput = "_qs-1";
export var shipmentModal = "_qs-2";
export var shipmentModalContent = "_qs-3";
export var tableContainer = "_qs-4";